const message = {
  _common: {
    seq: 'Seq.',
    name: 'Name',
    email: 'Email',
    avatar: 'Avatar',
    joinedDate: 'Joined Date',
    updatedDate: 'Updated Date',
    type: 'Type',
    groups: 'Groups',
    roles: 'Roles',
    action: 'Action',
    id: 'ID',
    createdDate: 'Created Date',
    cancel: 'Cancel',
    save: 'Save',
    remove: 'Remove',
    confirmRemove: 'Really remove',
    cost: 'Cost',
    month: 'Month',
    account: 'Account',
    invoiceMonth: 'Invoice Month',
    totalCost: 'Total Cost',
    no: 'No.',
    invoice: 'Invoice',
    report: 'Report',
    country: 'Country',
    date: 'Date',
    close: 'Close',
    product: 'Product',
    credit: 'Credit',
    reload: 'Reload',
    ok: 'OK',
    project: 'Project',
    service: 'Service',
    noData: 'No Data',
    startDate: 'Start Date',
    endDate: 'End Date',
    term: 'term',
    discount: 'Discount',
    total: 'Total',
    company: 'Company',
    originalCost: 'Original Cost',
    finalCost: 'Final Cost',
    vat: 'VAT',
    exchangeRate: 'Exchange Rate',
    undo: 'Undo',
    complete: 'Complete',
    viewerComplete: 'Data Update',
    transfer: 'Transfer',
    download: 'Download',
    cc: 'Cc',
    usage: 'Usage',
    usageUnit: 'Usage Unit',
    allProjects: 'All Projects',
    currency: 'Currency',
    region: 'Region',
    logout: 'Logout',
    mzAccount: 'Megazone Pops',
    freeTier: 'Free Tier',
    sustainedUsageDiscount: 'Sustained Usage Discount',
    committedUsageDiscount: 'Committed Usage Discount',
    spendingBasedDiscount: 'Spending Based Discount',
    feeUtilizationOffset: 'Fee Utilization Offset', //  차후 결정필요
    subscriptionBenefitDiscount: 'Subscription Benefit Discount',
    promotion: 'Promotion',
    applyDiscount: 'Apply Discount',
    pin_max: 'You can pin up to 5.',
    pin_exist: 'This account is already pinned.',
    language: 'Language',
    appearance: 'Appearance',
    light: 'Light',
    dark: 'Dark',
    auto: 'Auto',
    en: 'English',
    searchBy: 'Search by',
    projectName: 'Project Name',
    ko: 'Korean',
    megazone: 'Megazone',
    megazoneSoft: 'MegazoneSoft',
    megazoneCloud: 'MegazoneCloud',
    add: 'Add',
    dataIsEmpty: 'No Data',
    corporateCategory: 'Corporate Category',
    international: 'International',
    china: 'China',
    hongkong: 'HongKong',
    australia: 'Australia',
    all: 'All',
    includingRi: 'Including RI',
  },

  accountText: {
    customer: {
      account: 'Customer',
      accountsSummary: 'Customers Summary',
      accountNotify: 'Final cost for the selected customers',
    },
    tenancy: {
      account: 'Tenancy',
      accountsSummary: 'Tenancies Summary',
      accountNotify: 'Final cost for the selected tenancies',
    },
  },

  projectText: {
    subscription: {
      project: 'Subscription',
      allProjects: 'All Subscription',
      costByProject: 'Cost by Subscription',
      projectName: 'Subscription Name',
      projectId: 'Subscription Id',
    },
    compartment: {
      project: 'Compartment',
      allProjects: 'All Compartment',
      costByProject: 'Cost by Compartment',
      projectName: 'Compartment Name',
      projectId: 'Compartment Id',
    },
  },

  menu: {
    billing: 'Billing',
    summary: 'Summary',
    dataTransfer: 'Data Transfer',
    costPivot: 'Cost Pivot',
    costPivotBq: 'Cost Pivot',
    costAllocationTags: 'Cost Allocation Tags',
    invoice: '@:_common.invoice',
    personal: 'Personal',
    profile: 'Profile',
    admin: 'Admin',
    usageDetail: 'Usage Detail',
    cdn: 'CDN',
    alarm: 'Alarm',
    consolidated: 'Consolidated',
    commitmentAnalysis: 'Commitment Analysis',
    costTrend: 'Cost Trend',
    ipAccessControl: 'IP Access Control',
    costTable: 'Cost Table',
  },

  billing: {
    summary: {
      costByCountry: 'Cost by Country',
      costByProject: 'Cost by Project',
      costByService: 'Cost by Service',
      costByRegion: 'Cost by Region',
      name: '@:_common.name',
      cost: '@:_common.cost',
      dailyCost: 'Daily Cost',
      stackedCost: 'Daily Stacked Cost',
      forecastCost: 'Forecasted Cost',
      forecast: 'Forecast',
      detailInfo: 'Detail Information',
      close: '@:_common.close',
      totalCost: '@:_common.totalCost',
      credit: '@:_common.credit',
      project: '@:_common.project',
      undo: '@:_common.undo',
      promotionCredit: 'Promotion Credit',
      originalAmount: 'Original',
      remainAmount: 'Remain',
      more: 'More',
      allPromotionCredits: 'All Promotion Creadits',
      expiredAt: 'Expired Date',
      expiredCheck: 'Expired',
      accountBalance: 'Account Balance',
      balance: 'Balance',
    },

    dataTransfer: {
      internetEgress: 'INTERNET EGRESS',
      from: 'From',
      to: 'To',
      traffic: 'Traffic',
      cost: '@:_common.cost',
      internetIngress: 'INTERNET INGRESS',
      interRegionEgress: 'INTER REGION EGRESS',
      interRegionIngress: 'INTER REGION INGRESS',
      vpnInternetEgress: 'VPN INTERNET EGRESS',
      vpnInterRegionEgress: 'VPN INTER REGION EGRESS',
      vpnInterRegionIngress: 'VPN INTER REGION INGRESS',
    },

    costPivot: {
      preset: 'Preset',
      clearPreset: 'Clear',
      remove: '@:_common.remove',
      name: '@:_common.name',
      save: '@:_common.save',
      cancel: '@:_common.cancel',
      saveAs: 'Save as',
      empty: 'Empty',
      confirmRemove: '@:_common.confirmRemove',
      removePreset: 'Remove preset',
      download: 'Download',
      duplicate: 'Duplicate Name',
      oneMonth: 'One Month',
      threeMonths: 'Three Months',
      range: 'Range',
      startdate: 'Start date',
      enddate: 'End date',
      showTag: 'Show Tag Fields',
      load: 'Load',
    },

    costAllocationTags: {
      costTags: 'COST & TAGS',
      cost: '@:_common.cost',
      date: '@:_common.date',
      tag: 'Tag',
      credit: 'Credit',
      finalcost: 'Final Cost',
    },

    cdn: {
      usage: 'Usage',
    },

    invoice: {
      downloadUsage: 'Download Usage',
      viewInvoice: 'View Invoice',
      viewUsage: 'View Usage',
      viewReport: 'View Report',
      month: 'Month',
    },

    invoiceDetail: {
      invoice: '@:_common.invoice',
      no: '@:_common.no',
      account: '@:_common.account',
      id: '@:_common.id',
      name: '@:_common.name',
      invoiceMonth: '@:_common.invoiceMonth',
      gcpInvoiceNo: 'GCP Invoice No.',
      totalCost: '@:_common.totalCost',
      overview: 'Overview',
      projectId: 'Project ID',
      projectName: 'Project Name',
      service: 'Service',
      product: '@:_common.product',
      startDate: 'Start Date',
      endDate: 'End Date',
      cost: '@:_common.cost',
      company: '@:_common.company',
      serviceId: 'Service Id',
      serviceName: 'Service Name',
      type: 'Type',
    },

    alarm: {
      name: 'Alarm Name',
      addPromotionCredit: 'Add Promotion Credit Alarm',
      addAccountBalance: 'Add Account Balance Alarm',
      addBudget: 'Add Budget Alarm',
      modifyAlarm: 'Modify',
      removeAlarm: 'Remove',
      promotionCredit: 'Promotion Credit',
      remark: 'Remark',
      action: '@:_common.action',
      confirmRemove: '@:_common.confirmRemove',
      type: '@:_common.type',
      setting: 'Set Alarm Criteria',
      totalCredit: 'Total Credit',
      totalBalance: 'Total Balance',
      usageCredit: 'Usage Credit',
      usageBalance: 'Usage Balance',
      targetAmount: 'Target Amount',
      targetName: 'Target Name',
      creditName: 'Credit Name',
      balanceName: 'Balance Name',
      projectName: 'Project Name',
      serviceName: 'Service Name',
      budgetType: 'Budget Type',
      specifiedAmount: 'Specified Amount',
      lastMonthSpend: 'Last month spend',
      allProjects: 'All Projects',
      allServices: 'All Services',
      budgetDescription:
        'Set a monthly budget amount. Budgets begin on the first of the month, and reset at the beginning of each month.',
      specifiedAmountDescription:
        'A fixed amount that your spend will be compared against.',
      lastMonthSpendDescription:
        'A dynamic amount that updates each month based on the last month’s spend.',
      creditSettingDescription:
        'Send email notifications to users after the usage credit is a percentage of the total credit or a specified credit',
      balanceSettingDescription:
        'Send email notifications to users after the usage balance is a percentage of the total balance or a specified balance',
      budgetSettingDescription:
        'Send email notifications to users after the spend exceeds a percentage of the budget or a specified amount',
    },

    consolidated: {
      group: 'Group',
      thisMonthCost: 'This Month Cost',
      lastMonthCost: 'Last Month Cost',
      accountsSummary: 'Accounts Summary',
      dailyCost: 'Daily Cost',
      monthlyCost: 'Monthly Cost',
      ratio: 'Ratio',
      costByService: 'Cost By Service',
      costByRegion: 'Cost By Region',
      costByCountry: 'Cost By Country',
      serviceName: 'Service Name',
      regionName: 'Region Name',
      searchBy: 'Search by',
      account: 'Account',
      accountNotify: 'Final cost for the selected accounts',
      forecastCost: 'Forecasted Cost',
      forecast: 'Forecast',
      forecastAdditionalCost: 'Forecasted Additional Cost',
    },

    commitmentAnalysis: {
      commitmentType: 'Commitment Type',
      title: 'Commitments and average usage',
      allRegions: 'All Regions',
      allProjects: 'All Projects',
      activeCommitments: 'Active Commitments',
      commitmentUtilization: 'Commitment utilization',
      none: 'None',
      commitmentDesc: 'Commitment & utilization',
      averagePerMicrosecond: 'Average per microsecond',
      usage: 'Usage',
      activeCommitment: 'Active Commitment',
      utilizedCommitment: 'Utilized Commitment',
      unUtilizedCommitment: 'Un-utilized commitment',
      allUsage: 'All usage',
      commitmentUsage: 'Commitment covered usage',
      ondemandUsage: 'Eligible on-demand usage',
      highlights: 'Highlights',
      load: 'Load',
    },

    costTrend: {
      variance: 'Variance',
      costByProject: 'Cost By Project',
      costBySku: 'Cost By SKU',
      sku: 'SKU',
      skuName: 'SKU Name',
      apply: 'Apply',
      columnChart: 'ColumnChart',
      lineChart: 'LineChart',
    },

    costTable: {
      projectId: 'Project ID',
      serviceId: 'Service ID',
      skuId: 'SKU ID',
      locationCountry: 'Location/Country',
      zone: 'Zone',
      costType: 'Cost Type',
      usageUnit: 'Usage Unit',
      usageDate: 'Usage Date',
      usage: 'Usage',
      finalCost: 'Final Cost',
      tSystemMachineSpec: 'System Machine Spec',
      tSystemCores: 'System Cores',
      tSystemMemory: 'System Memory',
      freeTier: 'Free Tier',
      sustainedUsageDiscount: 'Sustained Usage Discount',
      committedUsageDiscount: 'Committed Usage Discount',
      spendingBasedDiscount: 'Spending Based Discount',
      feeUtilizationOffset: 'Fee Utilization Offset', //  차후 결정필요
      promotion: 'Promotion',
      currencyConversionRate: 'Currency Conversion Rate',
      oneMonth: 'One Month',
      threeMonths: 'Three Months',
      sixMonths: 'Six Months',
      oneYear: 'One Year',
      range: 'Range',
      reset: 'Reset',
      project: 'Project',
      service: 'Service',
      serviceName: 'Service Name',
      sku: 'SKU',
      skuName: 'SKU Name',
      projectName: 'Project Name',
      searchBy: 'Search by',
    },
  },

  personal: {
    profile: {
      seq: '@:_common.seq',
      name: '@:_common.name',
      email: '@:_common.email',
      avatar: '@:_common.avatar',
      joinedDate: '@:_common.joinedDate',
      updatedDate: '@:_common.updatedDate',
      groups: '@:_common.groups',
      roles: '@:_common.roles',
    },
    ipAccessControl: {
      description: 'Description',
      allowAllIP: 'Allow All IP',
      addAllowedIp: 'Add Allowed IP',
      modifyAllowedIp: 'Modify Allowed IP',
      removeAllowedIp: 'Remove Allowed IP',
      example: 'ex',
      or: 'or',
    },
  },

  admin: {
    searchField: {
      searchBy: 'Search by',
      costByProject: 'Cost By Project',
      costBySku: 'Cost By Sku',
      sku: 'SKU',
      skuname: 'Name of SKU',
      apply: 'Apply',
      columnChart: 'Column Chart',
      lineChart: 'Line Chart',
    },
  },

  material: {
    days: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    shorterDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    shortMonths: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ],
    shorterMonths: [
      'J',
      'F',
      'M',
      'A',
      'M',
      'Ju',
      'Ju',
      'A',
      'Se',
      'O',
      'N',
      'D',
    ],
  },

  error: {
    message: {
      404: 'The page you requested was not found.',
      403: 'Access denied. Please contact the administrator to register the verified email.',
      4036: 'IP address rejected. Please contact the administrator.',
    },
    redirectButton: 'Home',
  },
}

export default message
